import { captureAnalytics } from '../preload';

// Adoption signals for passive UI (tooltips, hover cards): capture an event at
// most once per browser-tab session instead of on every occurrence.
const MARKER_PREFIX = 'analytics_once:';

export const captureAnalyticsOncePerSession = (eventName, properties) => {
  const key = `${MARKER_PREFIX}${eventName}`;
  try {
    if (window.sessionStorage.getItem(key)) return;
    window.sessionStorage.setItem(key, 'true');
  } catch {
    // Locked-down browsers throw on sessionStorage; skip rather than track every occurrence.
    return;
  }
  captureAnalytics(eventName, properties);
};

// Called alongside posthog.reset() on sign-out so the next user in the same tab is counted.
export const resetSessionAnalytics = () => {
  try {
    Object.keys(window.sessionStorage).forEach((key) => {
      if (key.startsWith(MARKER_PREFIX)) window.sessionStorage.removeItem(key);
    });
  } catch {
    // Storage unavailable: nothing to clear.
  }
};
